export default __webpack_public_path__ + "js/lib/moment-timezone-with-data.js";